const SPOSITO_HOST = 'sposito.mangiamangia.app';

export function isAprilFoolsDay() {
    const now = new Date();
    return (
        (window.location.hostname === SPOSITO_HOST) &&
        now.getMonth() === 3 &&
        now.getDate() === 1
    );
}
